const CURRENT_TENANT_UUID_STORAGE_KEY = 'currentTenantUuid';
const CURRENT_ORGANIZATION_UUID_STORAGE_KEY = 'currentOrganizationUuid';

export const saveCurrentTenantUuid = (tenantUuid?: string | null) => {
  try {
    if (tenantUuid) {
      localStorage.setItem(CURRENT_TENANT_UUID_STORAGE_KEY, tenantUuid);
      return;
    }
    localStorage.removeItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    // ignore storage access errors
  }
};

export const readCurrentTenantUuid = () => {
  try {
    return localStorage.getItem(CURRENT_TENANT_UUID_STORAGE_KEY);
  } catch {
    return null;
  }
};

export const saveCurrentOrganizationUuid = (
  organizationUuid?: string | null,
) => {
  try {
    if (organizationUuid) {
      localStorage.setItem(
        CURRENT_ORGANIZATION_UUID_STORAGE_KEY,
        organizationUuid,
      );
      return;
    }
    localStorage.removeItem(CURRENT_ORGANIZATION_UUID_STORAGE_KEY);
  } catch {
    // ignore storage access errors
  }
};

export const readCurrentOrganizationUuid = () => {
  try {
    return localStorage.getItem(CURRENT_ORGANIZATION_UUID_STORAGE_KEY);
  } catch {
    return null;
  }
};
